module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-2-89ccbfacd461367015b54859431dc2be.png";